export class Assignment {
  assignmentId: string;
  userId: string;
  caseId: string;
  assignmentType: string;
  serverTime: number;
  expiryMinutes: number;
}
